export const ImportDetailsPermissions = {

  GetAllImportDetails :  {
    permissionsId: "51f5a4f4-06bb-4a40-0774-08dad1f91be5",
    permissionsName: "Get All Import Details",
    componentsId: null,
    components: null
  }
}
